import { AuthGuardService } from './services/auth-guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('./public/login/login.module').then(m => m.LoginPageModule)},
  { 
    path: 'secured', 
    canActivate: [AuthGuardService],
    loadChildren: () => import('./secured/secured-routing.module').then(m => m.SecuredRoutingModule)
  },
  {
    path: 'app-start',
    loadChildren: () => import('./public/app-start/app-start.module').then( m => m.AppStartPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
